// Angular
import { Component } from '@angular/core';

@Component({
	standalone: false,

	selector: 'kt-topbar',
	templateUrl: 'topbar.component.html',
	styleUrls: ['topbar.component.scss'],
})
export class TopbarComponent { }
